import React, { useState, useEffect } from "react";
import {
  FormContainer,
  FormHeader,
  FormField,
  SubmitButton,
  Message,
  ValidationError,
} from "./UserEditForm.styles";
import CpfInputField from "../FormField/CpfInputField";
import api from "../../services/api"; 

const UserEditForm = ({
  formData,
  onChange,
  onSubmit,
  isSubmitting,
  successMessage,
  errorMessage,
  validationErrors = {},
}) => {
  const [perfis, setPerfis] = useState([]);
  const [municipios, setMunicipios] = useState([]);
  const [regionais, setRegionais] = useState([]);


  useEffect(() => {
    const fetchPerfis = async () => {
      try {
        const response = await api.get("/users/perfis/list");
        setPerfis(response.data);
      } catch (error) {
        console.log(error)
        alert("Erro ao buscar perfis");
      }
    };

    const fetchMunicipios = async () => {
      let page = 1;
      let size = 853;
      try {
        const response = await api.get("/municipios/list", {
          params: { page, size }
        });
        setMunicipios(response.data);
      } catch (error) {
        console.log(error)
        alert("Erro ao buscar municípios");
      }
    };

    const fetchRegionais = async () => {
      let page = 1;
      let size = 28;
      try {
        const response = await api.get("/regionais/list", {
          params: { page, size }
        });
        setRegionais(response.data);
      } catch (error) {
        console.log(error)
        alert("Erro ao buscar regionais");
      }
    };

    fetchPerfis();
    fetchMunicipios();
    fetchRegionais();

  }, []);

  return (
    <FormContainer>
      <FormHeader>Editar Usuário</FormHeader>
      {errorMessage && <Message isError>{errorMessage}</Message>}
      <form onSubmit={onSubmit}>
        <FormField>
          <label htmlFor="nome">Nome de Usuário:</label>
          <input
            type="text"
            id="nome"
            name="nome"
            value={formData.nome || ""}
            onChange={onChange}
          />
          {validationErrors.nome && <ValidationError>{validationErrors.nome}</ValidationError>}
        </FormField>

        <FormField>
          <label htmlFor="email">E-mail:</label>
          <input
            type="text"
            id="email"
            name="email"
            value={formData.email || ""}
            onChange={onChange}
          />
          {validationErrors.email && <ValidationError>{validationErrors.email}</ValidationError>}
        </FormField>

        <FormField>
          <CpfInputField
            value={formData.cpf || ""}
            onChange={onChange}
            error={validationErrors.cpf}
          />
        </FormField>

        <FormField>
          <label htmlFor="perfil">Perfil:</label>
          <select
            id="perfil"
            name="perfil"
            value={formData.perfil?.id || formData.perfil || ""}
            onChange={onChange}
          >
            <option value="">Selecione...</option>
            {perfis.map((perfil) => (
              <option key={perfil.id} value={perfil.id}>
                {perfil.nome}
              </option>
            ))}
          </select>
          {validationErrors.perfil && <ValidationError>{validationErrors.perfil}</ValidationError>}
        </FormField>

        <FormField>
          <label htmlFor="municipio">Município:</label>
          <select
            id="municipio"
            name="municipio"
            value={formData.municipio || ""}
            onChange={(e) => {
              const codMunicipio = e.target.value;
              const municipioSelecionado = municipios.find(m => m.cod_ibge.toString() === codMunicipio);
              const codRegional = municipioSelecionado?.regional?.cod_urs || "";

              // Atualiza os dois campos com base no município selecionado
              onChange({
                target: { name: "municipio", value: codMunicipio }
              });
              onChange({
                target: { name: "regional", value: codRegional }
              });
            }}
          >
            <option value="">Selecione...</option>
            {municipios.map((municipio) => (
              <option key={municipio.cod_ibge} value={municipio.cod_ibge}>
                {municipio.nome}
              </option>
            ))}
          </select>
          {validationErrors.municipio && (
            <ValidationError>{validationErrors.municipio}</ValidationError>
          )}
        </FormField>

        <FormField>
          <label htmlFor="regional">Regional:</label>
          <select
            id="regional"
            name="regional"
            value={formData.regional || ""}
            onChange={onChange}
            disabled // opcional, já que será preenchido pelo município
          >
            <option value="">Selecione...</option>
            {regionais.map((regional) => (
              <option key={regional.cod_urs} value={regional.cod_urs}>
                {regional.nome}
              </option>
            ))}
            </select>
        </FormField>

        <SubmitButton type="submit" disabled={isSubmitting}>
          {isSubmitting ? "Atualizando..." : "Salvar Alterações"}
        </SubmitButton>
      </form>

      {successMessage && <Message>{successMessage}</Message>}
    </FormContainer>
  );
};

export default UserEditForm;
